import Attributes from '../views/attributes/Index.vue';
import { checkauth } from '../Helper';

// inserimento e modifica sono pagine: tornando indietro la lista riparte dal suo URL
const AttributeCreate = () => import('../views/attributes/Create.vue');
const AttributeEdit = () => import('../views/attributes/Edit.vue');

function auth(to, from, next) {
	checkauth().then(response => {
		if (response) {
			next();
		} else {
			next('/login');
		}
	});
}

export default [
	{
		path: '/attributes',
		name: 'Attribute',
		component: Attributes,
		beforeEnter: auth,
	},
	// prima di /attributes/:id, altrimenti "new" verrebbe letto come un id
	{
		path: '/attributes/new',
		name: 'attribute-new',
		component: AttributeCreate,
		beforeEnter: auth,
	},
	{
		path: '/attributes/:id',
		name: 'attribute-edit',
		component: AttributeEdit,
		beforeEnter: auth,
	},
];
